/* 🤖 this file was generated by svg-to-ts */
export const mgcIconBookmarkFilled: {
  name: 'bookmark-filled';
  data: string;
} = {
  name: 'bookmark-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.503 3.042A3.128 3.128 0 0 0 5.67 4.127c-.225.28-.511.853-.596 1.193-.044.182-.054 1.519-.054 7.66v7.44l.126.266c.16.338.39.568.728.728.237.112.305.126.626.126.304 0 .395-.016.58-.103.121-.057 1.278-.809 2.57-1.67l2.349-1.567 2.431 1.617c2.667 1.776 2.658 1.77 3.173 1.733a1.49 1.49 0 0 0 1.251-.864l.126-.266.011-7.32c.011-8.234.03-7.691-.287-8.36a2.935 2.935 0 0 0-1.408-1.428c-.647-.311-.245-.288-5.176-.297-2.431-.003-4.509.008-4.617.027"/></svg>`
};
